// extracted by mini-css-extract-plugin
export default {"container":"Navigation_container__oqhZU","safeArea":"Navigation_safeArea__G7uVd","hit":"Navigation_hit__2Imyo"};